'use client';

import SearchBar from '@/components/SearchBar/SearchBar';
import styles from './headerSearch.module.scss';

const HeaderSearch = () => {
  return (
    <div className={styles.desktopSearch}>
      <SearchBar variant="header" />
    </div>
  );
};

export default HeaderSearch;
